import React from "react";
import PropTypes from "prop-types";
import "./LoadingSpinner.css";

/**
 * Reusable loading spinner component
 */
const LoadingSpinner = ({
  size = "medium",
  text = "Loading...",
  centered = false,
}) => {
  const sizeClass = `loading-spinner-${size}`;
  const containerClass = centered
    ? "loading-spinner-container centered"
    : "loading-spinner-container";

  return (
    <div className={containerClass}>
      <div
        className={`loading-spinner ${sizeClass}`}
        role="status"
        aria-live="polite"
      >
        <div className="spinner"></div>
      </div>
      {text && <p className="loading-spinner-text">{text}</p>}
    </div>
  );
};

LoadingSpinner.propTypes = {
  size: PropTypes.oneOf(["small", "medium", "large"]),
  text: PropTypes.string,
  centered: PropTypes.bool,
};

export default LoadingSpinner;
